import React from 'react';
import {TopButtonAction, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import {ButtonToolbar} from "react-bootstrap";
import TopIf from "../../../../../componentsTopsa/if/TopIf";

export default class SzukajIPokazNaMapie extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            center: (Boolean(this.props.miejscowosc.dlGps) && Boolean(this.props.miejscowosc.szGps)) ? {
                lat: this.props.miejscowosc.szGps,
                lng: this.props.miejscowosc.dlGps
            } : {lat: 50.04, lng: 22},
            zoom: 12,
            mapTypeId: 'roadmap',
            lat: null,
            lng: null
        };
        this.getMap = this.getMap.bind(this)
        this.onPokazMiejscowosc = this.onPokazMiejscowosc.bind(this)
        this.onSzukajMiejscowoscPoNazwie = this.onSzukajMiejscowoscPoNazwie.bind(this)
        this.onClickZapiszWspolrzedne = this.onClickZapiszWspolrzedne.bind(this)
    }

    componentDidMount() {
        let map = this.getMap();
        if (Boolean(this.props.miejscowosc)) {
            let latlng = {lat: this.props.miejscowosc.szGps, lng: this.props.miejscowosc.dlGps}

            if (Boolean(this.props.miejscowosc.dlGps) && Boolean(this.props.miejscowosc.szGps)) {
                this.onPokazMiejscowosc(latlng)
            }
            else {
                this.onSzukajMiejscowoscPoNazwie(this.props.miejscowosc.nazMi)
            }
        }
    }

    componentWillReceiveProps(nextprops){

        if (Boolean(nextprops.miejscowosc)) {
            let latlng = {lat: nextprops.miejscowosc.szGps, lng: nextprops.miejscowosc.dlGps}

            if (Boolean(nextprops.miejscowosc.dlGps) && Boolean(nextprops.miejscowosc.szGps)) {
                this.onPokazMiejscowosc(latlng)
            }
            else {
                this.onSzukajMiejscowoscPoNazwie(nextprops.miejscowosc.nazMi)
            }
        }
    }

    getMap() {

        let map = new window.google.maps.Map(document.getElementById('map'), {
            center: this.state.center,
            zoom: this.state.zoom,
            mapTypeId: this.state.mapTypeId,
        });

        map.addListener('zoom_changed', () => {
            this.setState({
                zoom: map.getZoom()
            });
        });

        map.addListener('maptypeid_changed', () => {
            this.setState({
                mapTypeId: map.getMapTypeId(),
            });
        });

        return map
    }

    setMarker(wspolrzedne) {
        let marker = new window.google.maps.Marker({
            map: this.getMap(),
            position: wspolrzedne
        })
    }

    onPokazMiejscowosc(wspolrzedne) {
        this.setMarker(null)
        this.setState({center: wspolrzedne})
        this.getMap().setCenter(wspolrzedne)
        this.setMarker(wspolrzedne)
    }

    onSzukajMiejscowoscPoNazwie(miejscowosc) {
        this.setMarker(null)
        let geocoder = new window.google.maps.Geocoder;
        geocoder.geocode({address: miejscowosc}, function (results, status) {
            if (status == window.google.maps.GeocoderStatus.OK) {
                this.onPokazMiejscowosc({lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng()})
                this.setState({lat: results[0].geometry.location.lat(), lng: results[0].geometry.location.lng()})
            }
            else {
                alert('Nie znalezono takiego miejsca')
            }

        }.bind(this))
    }

    onClickZapiszWspolrzedne() {
        if (Boolean(this.state.lat) && Boolean(this.state.lng)) {
            this.props.handleZapiszWspolrzedneZMapy(this.state.lat, this.state.lng)
        } else {
            alert('Nie określono współrzędnych')
        }
    }

    render() {
        return (
            <div>
                <div>
                    <div className={'pull-right'} style={{marginBottom: '5px'}}>
                        <ButtonToolbar>
                            <TopIf isTrue={!((Boolean(this.props.miejscowosc.dlGps) && Boolean(this.props.miejscowosc.szGps)))}>
                                <TopButtonSave onClick={this.onClickZapiszWspolrzedne} text={'Zapisz współrzędne'} buttonSize={'medium'}/>
                            </TopIf>
                            <TopButtonAction onClick={() => {
                                this.props.handleZamknijMape()
                            }} btnColor={'default'} iconType={'fa fa-times'} btnSize={'medium'} text={'Zamknij mapę'}/>
                        </ButtonToolbar>
                    </div>
                </div>
                <div style={{clear: 'both'}}>
                    <div id='map' style={{height: '50vh'}}/>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/trasyConfig/miejscowosci/googleMapComponents/SzukajIPokazNaMapie.js